import script from "./TheBootCumTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./TheBootCumTemp.vue?vue&type=script&setup=true&lang=js"

import "./TheBootCumTemp.vue?vue&type=style&index=0&id=bd40c24e&lang=scss&scoped=true"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd40c24e"]])

export default __exports__